import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

import LogoImage from "../../assets/images/logo-light.svg";
import { ReactComponent as FacebookIcon } from "../../assets/images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../assets/images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/images/youtube-icon.svg";
import { ReactComponent as InstagramIcon } from "../../assets/images/instagram-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "../../assets/images/svg-decorator-blob-9.svg";
// import logo from "../../../assets/images/karodlogo.png";
import logo from "../../assets/images/logiclab.png";

const Container = tw.div`relative bg-primary-500 text-gray-100 -mb-8 -mx-8 px-8 py-20 lg:pt-24`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const FiveColumns = tw.div`flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;

const Column = tw.div`px-4 sm:px-0 sm:w-1/3 md:w-auto`;

const ColumnHeading = tw.h5`uppercase font-bold`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-100 pb-1 transition duration-300`;

const Divider = tw.div`my-8 border-b-2 border-gray-600 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-xl font-black tracking-wider text-gray-100`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-400`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-100 text-gray-900 hover:bg-gray-400 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`;
const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute top-0 left-0 w-80 h-80 transform -translate-x-20 -translate-y-32 text-primary-700 opacity-50`;
const DecoratorBlob2 = tw(
  SvgDecoratorBlob1
)`absolute bottom-0 right-0 w-80 h-80 transform  translate-x-32 translate-y-48 text-primary-700 opacity-50`;

const Footer = () => {
  return (
    <Container>
      <Content>
        <FiveColumns>
          <Column>
            <ColumnHeading>Company Contact</ColumnHeading>
            <LinkList>
            <LinkListItem>
                <Link>contact@logiclab.com.np</Link>
              </LinkListItem>
              <LinkListItem>
                <Link>logiclabit@gmail.com</Link>
              </LinkListItem>
              <LinkListItem>
                <Link>+977 9849472519</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Address</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="#">CM Street, Patan Dhoka</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="#">Lalitpur</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Product Contact</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link>karodapp@gmail.com</Link>
              </LinkListItem>
              <LinkListItem>
                <Link>+977 9849472519</Link>
              </LinkListItem>
              <LinkListItem>
                <Link>+977 9823820876</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Legal</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="https://karodapp.blogspot.com/2023/07/privacy-policy-for-karod-application.html" target="_blank">Privacy Policy</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="https://karodapp.blogspot.com/2023/07/terms-of-use.html" target="_blank">Terms of Use</Link>
              </LinkListItem>
            </LinkList>
          </Column>
        </FiveColumns>
        <Divider />
        <ThreeColRow>
          <LogoContainer>
            {/* <LogoImg wid src={logo} /> */}
            <img width={100} src={logo} />
            {/* <LogoText>Logic Lab.</LogoText> */}
          </LogoContainer>
          <CopywrightNotice><Link href="https://logiclab.com.np" target="_blank">&copy; {new Date().getFullYear()} Logic Lab. </Link>All Rights Reserved.</CopywrightNotice>
          <SocialLinksContainer>
            <SocialLink href="https://twitter.com/karodapp" target="_blank">
              <TwitterIcon />
            </SocialLink>
            <SocialLink href="https://www.instagram.com/karodapp" target="_blank">
              <InstagramIcon />
            </SocialLink>
            <SocialLink href="https://www.facebook.com/karodappofficial" target="_blank">
              <FacebookIcon />
            </SocialLink>

            <SocialLink href="https://www.youtube.com/@karodapp" target="_blank">
              <YoutubeIcon />
            </SocialLink>
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
      {/* <DecoratorBlobContainer>
        <DecoratorBlob1 />
        <DecoratorBlob2 />
      </DecoratorBlobContainer> */}
    </Container>
  );
};

export default Footer;